import { Injectable } from '@angular/core';

interface ICharactersToReplace {
    character: string;
    replacement: string;
}

@Injectable()
export class UrlHelperService {

    private charactersToiReplace: ICharactersToReplace[] = [
        {
            character: '.',
            replacement: '__dot__',
        }
    ];

    public replaceCharacters(urlPart: string): string {
        let output: string;

        this.charactersToiReplace.forEach((characterToReplace: ICharactersToReplace): void => {
            output = urlPart.split(characterToReplace.character).join(characterToReplace.replacement);
        });
        return output;
    }

    public retrieveCharacters(urlPart: string): string {
        let output: string;

        this.charactersToiReplace.forEach((characterToReplace: ICharactersToReplace): void => {
            output = urlPart.split(characterToReplace.replacement).join(characterToReplace.character);
        });
        return output;
    }

    public encodeUrlPart(urlPart: string): string {

        const urlPartEncoded: string = btoa(urlPart).split('=')[0];

        return urlPartEncoded;
    }

    public decodeUrlPart(urlPartEncoded: string): string {
        if (!urlPartEncoded) {
            return null;
        }
        const urlPartDecode: string = atob(urlPartEncoded);

        return urlPartDecode;
    }
}
